export const ORGANIZER_EVENTS = "ORGANIZER_EVENTS";
export const ATTENDEE_EVENTS = "ATTENDEE_EVENTS";
export const USER_EVENTS = "USER_EVENTS";

// export const HIDE_TOAST = "HIDE_TOAST";
